// Api key di google maps di fidelity
export const googleMapsApiKey = 'AIzaSyDq7e9r7ka45k4IUg2IAIPGNVqglNZAVZM';

// Api key usata all'inizio del progetto
// AIzaSyBgICVjDMQqkBYuIMrg9IFPLyRMAhZXlCA